import React, { useState, useRef, useEffect } from "react";
import {
    Box,
    Grid,
    Button,
} from "@mui/material";
import uploadIcon from './../../assets/images/signin/Upload icon.png';
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import SelectDropdown from "../../components/SelectDropdown/SelectDropdown";
import DragAndDrop from "../../components/ReusableForm/DragAndDrop/DragAndDrop";
import { IoIosClose } from "react-icons/io";
import Breadcrumb from "../../components/services/Breadcrumb/Breadcrumb";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import DescriptionEditor from "../../components/DescriptionEditor/DescriptionEditor";
import FileUploadRequest from "../../components/FileUpload/FileUploadRequest";
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { requestFormValidationSchema } from './../../utils/validation'
import { useFormik } from 'formik';
import { useDispatch, useSelector } from "react-redux";
import { fetchLookupData } from "../../redux/slices/lookupSlice";
import { fetchNotificationTypes } from "../../redux/slices/notificationTypeSlice";
import { fetchMainCategories } from "../../redux/slices/mainCategorySlice";
import { fetchSubCategories } from "../../redux/slices/subCategorySlice";
import InputField from '../../components/InputField/InputField';
import { submitNewOrderRequest, resetOrderState } from "../../redux/slices/orderSlice";
import SuccessMessage from "../../components/SuccessSnackbar/SuccessMessage";
import { useNavigate } from 'react-router-dom';
const RequestForm = () => {
    const { translations, direction, language } = useLanguage();
    const dispatch = useDispatch();
    const { isLoggedIn, user, token } = useSelector(state => state.login);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const navigate = useNavigate();
    const t = translations;
    
    const formik = useFormik({
        initialValues: {
            mainRequestType: "",
            subRequestType: "",
            RequestName: "",
            city: "",
            district: "",
            project: "",
            building: "",
            floor: "",
            unit: "",
            priority: "",
            description: "",
            Attachments: []
        },
        validationSchema: requestFormValidationSchema(t), // Adding the validation schema
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: (values) => {
            const formData = new FormData();
            // Append some example data
            formData.append("EquipmentID", formik.values.unit);
            formData.append("FunctionLocationID", formik.values.building);
            formData.append("Description", formik.values.description.replace(/<p>/g, '').replace(/<\/p>/g, ''));
            formData.append("NotificationTypeFk", formik.values.RequestName);
            formData.append("Periority", formik.values.priority);
            // formData.append("customerFk", user.id);
          
            if (uploadedFiles.length > 0) {
                uploadedFiles.forEach((file) => {
                    formData.append("Attachments", file);
                });
            }
            
            // Manually log the FormData contents
            for (let [key, value] of formData.entries()) {
                if (value instanceof File) {
                    // console.log(`${key}:`, value.name); 
                } else {
                    // console.log(`${key}:`, value); 
                }
            }
          
            // Dispatch the action to submit the form with FormData
            dispatch(submitNewOrderRequest({ formData, token }));
        }
    });
    
    const { isSubmitting, isSuccessful, errorMessage, responseData } = useSelector((state) => state.order);

    const { categories = [], loading: mainCategoryLoading } = useSelector(
        (state) => state.mainCategory || {} // Ensure state.mainCategory is not undefined
    );

    const { subCategories = [], loading: subCategoryLoading } = useSelector(
        (state) => state.subCategory || {} // Ensure state.subCategory is not undefined
    );
    const { notificationTypes = {}, loading: notificationLoading, error: notificationError } = useSelector(
        (state) => state.notificationTypes || {} // Ensure state.notificationTypes is not undefined
    );
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const resultAction = await dispatch(fetchMainCategories({ language })); // Dispatch the fetch action
            } catch (error) {
                console.error("Error fetching main categories:", error); // Log any error
            }
        };

        fetchCategories();
    }, [dispatch]);
    useEffect(() => {
        if (formik.values.mainRequestType) {
        
            dispatch(fetchSubCategories({mainCategoryId:formik.values.mainRequestType, language}))
                .then(response => {
                })
                .catch(error => {
                    // console.log('Error fetching subCategories:', error);
                });
        }
    }, [dispatch, formik.values.mainRequestType]);


    useEffect(() => {
        if (formik.values.subRequestType) {
            dispatch(fetchNotificationTypes({ subCategoryId: formik.values.subRequestType, language }));
        }
    }, [dispatch, formik.values.subRequestType]);
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);

    const selectFields = [
        {
            name: "mainRequestType",
            value: formik.values.mainRequestType,
            label: t.requestInformation.mainRequestType,
            options: categories?.map(category => ({
                id: category.MainCategoryId, // Set the ID as MainCategoryId
                name: category.NameLocalized, // Set the name as NameLocalized
            })) || [],
            error: formik.errors.mainRequestType,
            touched: formik.touched.mainRequestType,
            message: formik.touched.mainRequestType
                ? formik.errors.mainRequestType || ""
                : t.mainRequestTypeMessage, // Display message if no mainRequestType is selected
        },
        {
            name: "subRequestType",
            value: formik.values.subRequestType,
            label: t.requestInformation.subRequestType,
            options: formik.values.mainRequestType
                ? subCategories?.map(subCategory => ({
                    id: subCategory.SubCategoryId,
                    name: subCategory.SubCategoryLocalized
                })) || []
                : [],
            error: formik.errors.subRequestType,
            touched: formik.touched.subRequestType,
            message: formik.values.mainRequestType
                ? formik.touched.subRequestType
                    ? formik.errors.subRequestType || ""
                    : ""
                : t.mainRequestTypeMessage, // Message to prompt selecting mainRequestType first
        },
        {
            name: "RequestName",
            value: formik.values.RequestName,
            label: t.requestInformation.studentName,
            options: formik.values.subRequestType
                ? (notificationTypes[formik.values.subRequestType] || []).map(notification => ({
                    id: notification.NotificationTypeId,
                    name: notification.TypeNameLocalized,
                }))
                : [],
            error: formik.errors.RequestName,
            touched: formik.touched.RequestName,
            message: formik.values.subRequestType
                ? formik.touched.RequestName
                    ? formik.errors.RequestName || ""
                    : ""
                : t.subRequestTypeMessage, // Message to prompt selecting subRequestType first
        },
    ];

    const { lookups, loading, error } = useSelector((state) => state.lookup);
    const fetchIfNotLoaded = (lookupNumber, parentId) => {
            dispatch(fetchLookupData({ lookupNumber, parentId, language,customerFk:user.id }));
    };
    useEffect(() => {
        fetchIfNotLoaded(1, null); // Always fetch city
        if (formik.values.city) fetchIfNotLoaded(2, formik.values.city);
        if (formik.values.district) fetchIfNotLoaded(3, formik.values.district);
        if (formik.values.project) fetchIfNotLoaded(4, formik.values.project);
        if (formik.values.building) fetchIfNotLoaded(5, formik.values.building);
        if (formik.values.floor) fetchIfNotLoaded(6, formik.values.floor);
    }, [
        dispatch,
        formik.values.city,
        formik.values.district,
        formik.values.project,
        formik.values.building,
        formik.values.floor,
    ]);

    const handleFileSelect = (e) => {
        if (e.target.files && e.target.files[0]) {
            setUploadedFiles((prev) => [...prev, ...e.target.files]);
        }
    };
    const fields = [
        {
            name: "city",
            label: t.city,
            value: formik.values.city,
            options: lookups[1] || [],
            error: formik.errors.city,
            touched: formik.touched.city,
        },
        {
            name: "district",
            label: t.district,
            value: formik.values.district,
            options: formik.values.city ? (lookups[2] || []) : [],

            error: formik.errors.district,
            touched: formik.touched.district,
            message: formik.values.city ? "" : t.cityMessage,
        },
        {
            name: "project",
            label: t.project,
            value: formik.values.project,
            options: formik.values.district ? (lookups[3] || []) : [],

            error: formik.errors.project,
            touched: formik.touched.project,
            message: formik.values.district ? "" : t.districtMessage,
        },
        {
            name: "building",
            label: t.building,
            value: formik.values.building,
            options: formik.values.project ? (lookups[4] || []) : [],

            error: formik.errors.building,
            touched: formik.touched.building,
            message: formik.values.project ? "" : t.projectMessage,
        },
        {
            name: "floor",
            label: t.floor,
            value: formik.values.floor,
            options: formik.values.building ? (lookups[5] || []) : [],

            error: formik.errors.floor,
            touched: formik.touched.floor,
            message: formik.values.building ? "" : t.buildingMessage,
        },
        {
            name: "unit",
            label: t.unit,
            value: formik.values.unit,
            options: formik.values.floor ? (lookups[6] || []) : [],

            error: formik.errors.unit,
            touched: formik.touched.unit,
            message: formik.values.floor ? "" : t.floorMessage,

            // disabled: newUnitAdded || !formik.values.floor
        },
        {
            name: "priority",
            label: t.unitDetails.priority, 
            value: formik.values.priority,
            options: [
                { id: 1, name: t.high },   // High priority
                { id: 2, name: t.medium }, // Medium priority
            ], // List of options for priority
            error: formik.errors.priority,
            touched: formik.touched.priority,
            // message: formik.errors.priority,
        },
    ];
    const [formData, setFormData] = useState(
        [...selectFields, ...fields].reduce((acc, field) => {
            acc[field.name] = ""; // Initialize all fields with an empty value
            return acc;
        }, {})
    );
    // Unified onChange handler
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleDescriptionChange = (value) => {
        formik.setFieldValue("description", value);
        formik.validateField("description");
    };


    const supportedFileTypes = [
        "image/jpeg", "image/png", "image/gif", "video/mp4", "application/pdf",
        "application/vnd.adobe.photoshop", "application/psd", "application/msword",
        "application/vnd.ms-powerpoint"
    ];
    const handleSuccess = () => {
        formik.resetForm();
        dispatch(resetOrderState());
    };
    const handleFileDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = Array.from(e.dataTransfer.files);
        setUploadedFiles((prevFiles) => [...prevFiles, ...files]);
    };
    const handleCancel = () => {
        window.scrollTo(0, 0);
        navigate('/');  
    };
    if (!isLoggedIn) {
        navigate('/signin');
        return null;
    }
    return (
        <Box dataAos="zoom-in" >
            {/* Breadcrumb */}
            <Breadcrumb items={[t.newRequest]} />
            {isSuccessful ? (
                <SuccessMessage
                    message={t.RequestMsg}
                    onReset={handleSuccess}
                />
            ) : (
                <Box
                    sx={{
                        maxWidth: 1200,
                        mx: "auto",
                        p: 4,
                        mt: 4,
                        mb: 4

                    }}
                >
                    <form onSubmit={formik.handleSubmit}>
                        {/* Request Information Section */}
                        <Box sx={{
                            p: 3, mb: 6, border: "1px solid #CED4DA", borderRadius: "16px", boxShadow: "0px 4px 4px 0px #00000040"
                        }}>
                            <SectionTitle
                                title={t.requestInformation1}
                                sx={{
                                    fontSize: "18px", borderBottom: "1px solid #0000001A",
                                    pb: 1,
                                }}
                            />
                            <Grid container spacing={3}>

                                {selectFields.map((field, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <SelectDropdown
                                            key={index}
                                            disabled={field.disabled}
                                            name={field.name}
                                            label={field.label}
                                            value={field.value}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            options={field.options.length > 0 ? field.options : []}
                                            error={field.error}
                                            touched={field.touched}
                                            required
                                            helperText={field.message}
                                            t={t}
                                            direction={direction}
                                        />
                                    </Grid>
                                ))}
                                {/* Use DescriptionEditor for the description field */}
                                <DescriptionEditor
                                    title={t.requestInformation.description}
                                    value={formik.values.description}
                                    onChange={handleDescriptionChange}
                                    placeholder={t.descriptionPlaceholder}
                                    height="200px"
                                    t={t}
                                    direction={direction}
                                    onBlur={formik.handleBlur}  // Formik's onBlur should be passed to the editor
                                    error={formik.touched.description && Boolean(formik.errors.description)}
                                    helperText={formik.touched.description && formik.errors.description}
                                    name="description" // Make sure you pass the name of the field for validation
                                />

                            </Grid>
                        </Box>


                        {/* Unit Details Section */}
                        <Box
                            sx={{
                                p: 3, mb: 6,
                                border: "1px solid #CED4DA",
                                borderRadius: "16px",
                                boxShadow: "0px 4px 4px 0px #00000040",
                            }}
                        >
                            <SectionTitle
                                title={t.UnitDetails1}
                                sx={{
                                    fontSize: "18px", borderBottom: "1px solid #0000001A",
                                    pb: 1,
                                }}
                            />
                            <Grid container spacing={2}>
                                {/* Map over the fields to create the Select elements */}
                                {fields.map((field, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <SelectDropdown
                                            disabled={field.disabled}
                                            name={field.name}
                                            label={field.label}
                                            value={field.value}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            options={field.options.length > 0 ? field.options : []}
                                            error={field.error}
                                            touched={field.touched}
                                            imageSrc={field.imageSrc}
                                            required
                                            helperText={field.message}
                                            t={t}
                                            direction={direction}
                                        />
                                    </Grid>
                                ))}
                               
                            </Grid>

                        </Box>
                        {/* File Upload Section */}
                        <Box sx={{
                            p: 3, mb: 6, border: "1px solid #CED4DA", borderRadius: "16px", boxShadow: "0px 4px 4px 0px #00000040"
                        }}>
                            <SectionTitle
                                title={t.fileUpload.title}
                                sx={{
                                    fontSize: "18px", borderBottom: "1px solid #0000001A",
                                    pb: 1
                                }}
                            />
                            <FileUploadRequest
                                onFileSelect={handleFileSelect}
                                supportedFileTypes={supportedFileTypes}
                                uploadedFiles={uploadedFiles}
                                setUploadedFiles={setUploadedFiles}
                                uploadIcon={uploadIcon}
                                fileInputRef={fileInputRef}
                                buttonLabel={t.browse}
                                onDrop={handleFileDrop}
                            />
                        </Box>
                        {/* Action Buttons */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end", // Align buttons to the right
                                gap: 2, // Space between buttons
                                mt: 4, // Add spacing from the previous section
                            }}
                        >
                            {/* {isSuccessful && <p>Order request was successful!</p>}
                            {errorMessage && <p>Error: {error}</p>} */}
                            <Button
                                type="submit" disabled={loading}
                                variant="contained"
                                sx={{ px: 4, backgroundColor: "#12538B", color: "#fff", fontWeight: 700 }}
                            >
                                {isSubmitting ? t.submit : t.buttons.add}

                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                sx={{ px: 4, fontWeight: 700 }}
                                onClick={() => setFile(null)} // Clear file selection on click
                            >
                                {t.buttons.clear}
                            </Button>
                            <Button
                                variant="outlined"
                                color="error"
                                sx={{ px: 4, fontWeight: 700 }}
                                onClick={handleCancel} 
                            >
                                {t.buttons.cancel}
                            </Button>
                        </Box>
                    </form>
                </Box>
            )}
        </Box>
    );
};

export default RequestForm;
